import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from './cmsConfig';
import { PremiumPaymentThresholdContainer } from './types/Config';

export interface RootRedirectRule {
  enabled?: boolean;
  hosts?: string[];
  targetPath?: string;
}

export interface ReactConfig {
  applicationInsightsConnectionString: string;
  premiumPaymentThreshold: PremiumPaymentThresholdContainer;
  intelligentServicesApiUrl: string;
  intelligentServicesCompaniesApiUrl: string;
  intelligentServicesAuthApiUrl: string;
  appEnvironment: string;
  bankIdTestIndex: string;
  gtmContainerId?: string;
  cookieBotId?: string;
  rootRedirectRules?: RootRedirectRule[];
  rootRedirectHost?: string;
  rootRedirectTargetPath?: string;
}

export const configApi = createApi({
  reducerPath: 'configApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getReactConfig: builder.query<ReactConfig, void>({
      query: () => ({
        url: `/configuration/react`,
        headers: {
          'X-CSRF': '1',
        },
        credentials: 'include',
      }),
    }),
  }),
});

export const { useLazyGetReactConfigQuery, useGetReactConfigQuery } = configApi;
